/**
 * Product Grid Advertisement Positioning
 * Handles positioning of advertisement blocks within the product grid
 */

class ProductGridAdverts {
  constructor() {
    this.adverts = null;
    this.grid = null;
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.positionAdverts());
    } else {
      this.positionAdverts();
    }

    // Re-position adverts on pagination or filter changes
    this.observeGridChanges();
  }

  positionAdverts() {
    this.adverts = document.querySelectorAll('.product-grid-adverts-container .product-grid-advert');
    this.grid = document.querySelector('.product-grid');

    if (!this.grid || this.adverts.length === 0) {
      return;
    }

    // Hide all adverts initially and move them to the grid
    this.adverts.forEach(advert => {
      if (advert instanceof HTMLElement && this.grid) {
        advert.style.display = 'none';
        // Move the advert to the grid
        this.grid.appendChild(advert);
      }
    });

    // Position each advert
    this.adverts.forEach(advert => {
      this.positionSingleAdvert(advert);
    });
  }

  /**
   * Position a single advertisement in the grid
   * @param {Element} advert 
   */
  positionSingleAdvert(advert) {
    const position = parseInt(advert.getAttribute('data-position') || '0');
    const persId = advert.classList.contains('product-grid-advert__pers') ? 
      advert.className.match(/product-grid-advert__pers-(\w+)/)?.[1] : null;

    // Check date restrictions
    if (advert.classList.contains('product-grid-advert--date-hide')) {
      if (!this.isWithinDateRange(advert)) {
        return;
      }
    }

    // Find the target position in the grid
    if (this.grid) {
      const targetProduct = this.grid.querySelector(`[data-position="${position}"]`);
      
      if (targetProduct) {
        // Insert the advert after the target product
        targetProduct.insertAdjacentElement('afterend', advert);
        if (advert instanceof HTMLElement) {
          advert.style.display = 'block';
        }
      } else {
        // If position doesn't exist, try to append at the end
        this.grid.appendChild(advert);
        if (advert instanceof HTMLElement) {
          advert.style.display = 'block';
        }
      }
    }
  }

  /**
   * Check if advert should be shown based on date range
   * @param {Element} advert 
   * @returns {boolean}
   */
  isWithinDateRange(advert) {
    // This would need to be implemented based on your date logic
    // For now, return true to show all adverts
    return true;
  }

  observeGridChanges() {
    // Watch for changes in the grid (pagination, filtering, etc.)
    if (this.grid) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            // Delay to allow grid to settle
            setTimeout(() => this.positionAdverts(), 100);
          }
        });
      });

      observer.observe(this.grid, {
        childList: true,
        subtree: true
      });
    }

    // Also listen for pagination events
    document.addEventListener('page:loaded', () => {
      setTimeout(() => this.positionAdverts(), 100);
    });

    // Listen for filter changes
    document.addEventListener('facets:updated', () => {
      setTimeout(() => this.positionAdverts(), 100);
    });
  }
}

// Initialize when the script loads
document.addEventListener('DOMContentLoaded', () => {
  new ProductGridAdverts();
});

// Also initialize immediately if DOM is already ready
if (document.readyState !== 'loading') {
  new ProductGridAdverts();
}
